import { useSelector } from "react-redux";
import AgentTitle from "../components/Common/AgentTitle";
import HamburguerMenu from "../components/Common/HamburguerMenu";
import LanguageDropdown from "../components/Common/LanguageDropdown";
import ProfileDropdown from "../components/Common/ProfileDropdown";
import { selectPageTitle, selectCurrentModel } from "../redux/layout";

interface HeaderProps {
  headerClass: string;
}

const Header = ({ headerClass }: HeaderProps) => {
  const title = useSelector(selectPageTitle);
  const model = useSelector(selectCurrentModel);

  return (
    <>
      <header id="page-topbar" className={headerClass}>
        <div className="layout-width">
          <div className="navbar-header">
            <div className="d-flex">
              <HamburguerMenu />
              <AgentTitle title={title} model_name={model || ""} />
            </div>
            <div className="d-flex align-items-center">
              <LanguageDropdown />
              <ProfileDropdown />
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
